module.exports = __webpack_public_path__ + "static/media/reprint_lsr_icon.860b74a3.svg";